import { Visibility } from "@mui/icons-material";
import { Paper, styled } from "@mui/material";

export const StyledUploadedFile = {
  Container: styled("div")(({ theme }) => ({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflow: "auto",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 2,
    paddingBottom: 5,
    [theme.breakpoints.down("sm")]: {
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
  })),

  Card: styled("div")(({ theme }) => ({
    display: "flex",
    marginTop: 10,
    marginBottom: 5,
    [theme.breakpoints.down("sm")]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5),
    },
  })),

  FilesContainer: styled(Paper)({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 10,
  }),

  ActionsContainer: styled(Paper)(({ theme }) => ({
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginLeft: 5,
    borderRadius: 10,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      padding: '10px',
      justifyContent: 'space-around',
    },
  })),

  button: {
    cursor: "pointer",
    marginRight: 2,
    marginLeft: 2,
  },
  disabledButton: {
    marginRight: 2,
    color: "grey",
    marginLeft: 2,
  },
  VisibilityIcon: styled(Visibility)(({ theme }) => ({
    color: theme.palette.primary.main,
    fontSize: 24,
    marginLeft: 5,
  })),
};
